module.exports = __webpack_public_path__ + "img/llenar_lapiz.7a845d19.png";